<template>
  <div class="wraper">
    <div class="block" style="float:left;width: 100%;margin-bottom: 4px">
      <div style="padding-bottom: 10px">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="router">已启用设备</el-breadcrumb-item>
          <el-breadcrumb-item>柜内监控</el-breadcrumb-item>
          <el-breadcrumb-item> 资产号：{{ assetsNum }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <el-date-picker
        v-model="dateTime"
        type="daterange"
        align="right"
        :clearable='clearDate'
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        size="mini"
        end-placeholder="结束日期"
        :picker-options="pickerOptions2"
        style="padding-top: 1.2px"
        value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-button @click="searchTable" size="mini" type="primary">搜索</el-button>
<!--      <div class="block" style="float:right">-->
<!--        <el-button @click="$router.back(-1)" size="mini" type="info">返回</el-button>-->
<!--      </div>-->
    </div>
    <el-table
      ref="filterTable"
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="orderTime"
        label="时间"
      >
      </el-table-column>
      <el-table-column
        prop="floor"
        label="照片"
      >
        <template slot-scope="scope">
          <el-popover
            placement="right"
            title=""
            trigger="hover">
            <img :src="scope.row.imageObj" style="max-height: 550px;max-width: 530px"/>
            <img slot="reference" :src="scope.row.imageObj" :alt="scope.row.imageObj" style="max-height: 350px;max-width: 330px">
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>

</template>

<script>
    export default {
        name: 'devicesImages',
        data() {
            return {
                router: '/devicesStart',
                multipleSelection: [],
                tableData: [],
                options: [],
                total: 0,
                pagesize: 10,
                currentPage: 1,
                pickerOptions2: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - (1000 * 60 * 60 * 24);
                    },
                    shortcuts: [{
                        text: '昨天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dateTime: this.getDefaultDay(),
                clearDate: false,
                getImageList: '',
                assetsNum: ''
            }
        },
        mounted() {
            //获取上一页面参数
            console.log(this.$route.query)
            this.getImageList = this.$route.query.url;
            this.assetsNum = this.$route.query.assetsNum;
            this.getData();
        },
        methods: {
            getDefaultDay() {
                let date = new Date();
                let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8);
                let startyear = startdate.getFullYear();
                let startmonth = startdate.getMonth() + 1;
                if (startmonth < 10) {
                    startmonth = "0" + startmonth;
                }
                let startday = startdate.getDate();
                if (startday < 10) {
                    startday = "0" + startday;
                }
                startdate = startyear + '-' + startmonth + '-' + startday;
                let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
                let endyear = enddate.getFullYear();
                let endmonth = enddate.getMonth() + 1;
                if (endmonth < 10) {
                    endmonth = "0" + endmonth;
                }
                let endday = enddate.getDate();
                if (endday < 10) {
                    endday = "0" + endday;
                }
                enddate = endyear + '-' + endmonth + '-' + endday;
                return [startdate, enddate];
            },
            getData() {
                let param = {
                    pageSize: this.pagesize,
                    pageNum: this.currentPage,
                    startDay: this.dateTime[0],
                    endDay: this.dateTime[1],
                    assetsNum: this.assetsNum,
                    cabinetStatus: this.transType
                }, url = this.getImageList;
                // get
                this.$ajax.post(url, param)
                    .then((res) => {
                        var data = res.data
                        if (data.code == 200) {
                            this.total = data.data.total
                            this.tableData = this.formatData(data.data.list);
                            this.pagesize = data.data.pageSize
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch((err) => {
                    this.$message.error('请求失败')
                })
            },
            formatData(data) {
                var temp = data;
                var arr = [];
                for (var i = 0; i < temp.length; i++) {
                    var row = temp[i];
                    var obj = {}
                    obj.assetsNum = row.assetsNum;
                    obj.orderTime = row.orderTime;
                    obj.imageObj = row.imageUrl;
                    arr.push(obj)
                }
                return arr;
            },
            searchTable() {
                // console.log(11)
                this.pageNum = 1;
                this.getData();
            },
            handleSizeChange: function (size) {
                this.pagesize = size;
                this.currentPage = 1;
                this.getData()
            },
            handleCurrentChange: function (currentPage) {
                this.currentPage = currentPage;
                this.getData()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/pages/devices/devicesImages.vue